<template>
  <div class="home">
    <div v-if="$store.state.linkInfo.resourceUrl">
      <div class="desc-text">用微信扫描下方的小程序码，打开微信小程序</div>
      <img :src="$store.state.linkInfo.resourceUrl" >
    </div>
  </div>
</template>
<script>
import { _mountedfun } from "../../views/utils/tools.js";
export default {
  name: "Home",
  data() {
    return {
      adsCode: "",
      adsCodeData: {
        maxmara_baidu: require("../../assets/maxmara_baidu.gif"),
        levis_20220618: require("../../assets/Levis.jpg"),
        levis_20220609: require("../../assets/levis_0609.jpg"),
        levis_202207261:require("../../assets/levis_726.png"),
        levis_202207262:require("../../assets/levis_726.png")
      },
      resourceUrl: ''
    };
  },
  components: {},
  mounted() {
    _mountedfun(this)
  },
};
</script>
<style lang="scss" scoped>
.home {
  // width: 100vw;
  // height: 100vh;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.desc-text {
  font-size: 26px;
}
img {
  margin-top: 50px;
}
</style>
